package com.applaunchkit.website.components

import androidx.compose.runtime.Composable
import com.applaunchkit.website.style.TextSelectionStyle
import com.applaunchkit.website.util.Constants.LATO_REGULAR
import com.applaunchkit.website.util.Constants.SUPPORT_EMAIL
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Footer(largeBreakpoint: Boolean) {
    if (largeBreakpoint) {
        Row(
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px, top = 100.px, right = 20.px)
                    .color(Colors.White.copy(alpha = 200))
                    .fontFamily(LATO_REGULAR)
                    .fontSize(0.9.cssRem)
                    .lineHeight(value = 1.1)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.open("/privacy")
                    }
                    .toAttrs()
            ) {
                Text(value = "Privacy Policy")
            }
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px, top = 100.px, right = 20.px)
                    .color(Colors.White.copy(alpha = 200))
                    .fontFamily(LATO_REGULAR)
                    .fontSize(0.9.cssRem)
                    .lineHeight(value = 1.1)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.open("/terms")
                    }
                    .toAttrs()
            ) {
                Text(value = "Terms of Service")
            }
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px, top = 100.px)
                    .color(Colors.White.copy(alpha = 127))
                    .fontFamily(LATO_REGULAR)
                    .fontSize(0.9.cssRem)
                    .lineHeight(value = 1.1)
                    .toAttrs()
            ) {
                Text(value = SUPPORT_EMAIL)
            }
        }
    } else {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(12.px)
        ) {
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px)
                    .color(Colors.White.copy(alpha = 200))
                    .fontFamily(LATO_REGULAR)
                    .fontSize(0.9.cssRem)
                    .lineHeight(value = 1.1)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.open("/privacy")
                    }
                    .toAttrs()
            ) {
                Text(value = "Privacy Policy")
            }
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px)
                    .color(Colors.White.copy(alpha = 200))
                    .fontFamily(LATO_REGULAR)
                    .fontSize(0.9.cssRem)
                    .lineHeight(value = 1.1)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.open("/terms")
                    }
                    .toAttrs()
            ) {
                Text(value = "Terms of Service")
            }
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px)
                    .color(Colors.White.copy(alpha = 127))
                    .fontFamily(LATO_REGULAR)
                    .fontSize(0.9.cssRem)
                    .lineHeight(value = 1.1)
                    .toAttrs()
            ) {
                Text(value = SUPPORT_EMAIL)
            }
        }
    }
}